import { Meta } from "@/shared/components";
import { BillingSellerSettings } from "@/admin/features/billing";

export function BillingSellerPage() {
  return (
    <>
      <Meta title="Реквизиты продавца" />
      <BillingSellerSettings />
    </>
  );
}
